export const preloaderActiveClassName = "preloader_active";

export const placeholder = "";
